import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import SendIcon from "@mui/icons-material/Send";
import LoadingButton from "@mui/lab/LoadingButton";

export default function OrtodonciaLiquidacionesTabla({
  liquidaciones,
  onEnviarMail,
  enviandoMailId,
}) {
  if (!liquidaciones || liquidaciones.length === 0) {
    return (
      <Box
        sx={{
          mt: 2,
          p: 4,
          borderRadius: 2,
          border: "1px dashed",
          borderColor: "grey.300",
          backgroundColor: "grey.50",
          textAlign: "center",
        }}
      >
        <Typography
          variant="subtitle1"
          fontWeight="bold"
          color="text.secondary"
        >
          Sin liquidaciones cerradas
        </Typography>
        <Typography variant="body2" color="text.disabled" sx={{ mt: 0.5 }}>
          No se encontraron liquidaciones cerradas para el período y clínica
          seleccionados.
        </Typography>
      </Box>
    );
  }

  const periodoLabel = (mes, anio) => `${String(mes).padStart(2, "0")}/${anio}`;

  const formatMoneda = (valor) =>
    new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency: "ARS",
      minimumFractionDigits: 2,
    }).format(valor ?? 0);

  const totalHonorarios = liquidaciones.reduce(
    (acc, liq) => acc + (liq.total_honorarios ?? 0),
    0,
  );

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
        Liquidaciones cerradas —{" "}
        {periodoLabel(
          liquidaciones[0].periodo_mes,
          liquidaciones[0].periodo_anio,
        )}
      </Typography>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: "primary.main" }}>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Odontólogo
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Email
              </TableCell>
              <TableCell
                sx={{ color: "white", fontWeight: "bold" }}
                align="right"
              >
                Honorarios
              </TableCell>
              <TableCell
                sx={{ color: "white", fontWeight: "bold" }}
                align="center"
              >
                Acciones
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {liquidaciones.map((liq, index) => (
              <TableRow
                key={liq.id}
                hover
                sx={{
                  backgroundColor: index % 2 === 0 ? "inherit" : "grey.50",
                }}
              >
                <TableCell>{liq.odontologo}</TableCell>
                <TableCell>
                  <Typography variant="caption" color="text.secondary">
                    {liq.email ?? "Sin email"}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  {formatMoneda(liq.total_honorarios)}
                </TableCell>
                <TableCell>
                  <Box
                    sx={{ display: "flex", gap: 1, justifyContent: "center" }}
                  >
                    {liq.url_excel && (
                      <Button
                        variant="contained"
                        size="small"
                        startIcon={<DownloadIcon />}
                        href={liq.url_excel}
                        target="_blank"
                        sx={{
                          backgroundColor: "#1D6F42",
                          ":hover": { bgcolor: "#155534" },
                          textTransform: "none",
                        }}
                      >
                        Excel
                      </Button>
                    )}
                    {liq.url_pdf && (
                      <Button
                        variant="contained"
                        size="small"
                        startIcon={<PictureAsPdfIcon />}
                        href={liq.url_pdf}
                        target="_blank"
                        sx={{
                          backgroundColor: "#C62828",
                          ":hover": { bgcolor: "#8e0000" },
                          textTransform: "none",
                        }}
                      >
                        PDF
                      </Button>
                    )}
                    {liq.url_pdf && (
                      <LoadingButton
                        variant="contained"
                        size="small"
                        startIcon={<SendIcon />}
                        loading={enviandoMailId === liq.id}
                        loadingPosition="start"
                        onClick={() => onEnviarMail(liq)}
                        disabled={!liq.email}
                        sx={{
                          backgroundColor: "#1565C0",
                          ":hover": { bgcolor: "#0d47a1" },
                          textTransform: "none",
                        }}
                      >
                        Mail
                      </LoadingButton>
                    )}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
            <TableRow sx={{ backgroundColor: "primary.main" }}>
              <TableCell
                colSpan={2}
                align="right"
                sx={{ color: "white", fontWeight: "bold" }}
              >
                TOTAL
              </TableCell>
              <TableCell
                align="right"
                sx={{ color: "white", fontWeight: "bold" }}
              >
                {formatMoneda(totalHonorarios)}
              </TableCell>
              <TableCell />
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
